import "jquery/dist/jquery.min";
import "datatables.net-bs5/js/dataTables.bootstrap5.min";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "bootstrap/dist/js/bootstrap.min";
import "bootstrap/dist/css/bootstrap.min.css";

import "../../assets/stylesheets/application.scss";

import DataTable from "datatables.net-bs5";
document.addEventListener("DOMContentLoaded", function () {
  let table = new DataTable("#roster", {
    order: [[0, "asc"]],
    paging: false,
    searching: true,
    select: true,
    deferRender: true,
    dom: '<"toolbar">frtip',
    initComplete: function () {
      this.api()
        .columns([3, 4, 5])
        .every(function () {
          let column = this;
          let title = column.header();
          let filterTitle = $(title).text();

          let select = $(
            `<select class="form-select" id="${filterTitle}"><option value=""></option></select>`,
          )
            .appendTo("#roster-filter-dropdowns")
            .on("change", function () {
              let val = $.fn.dataTable.util.escapeRegex($(this).val());

              column.search(val ? "^" + val + "$" : "", true, false).draw();
            });

          column
            .data()
            .unique()
            .sort()
            .each(function (d, j) {
              select.append(`<option value="${d}">${d}</option>`);
            });
          $("#roster-filter-titles").append(
            `<label class="d-block w-100" for="${filterTitle}">Filter by ${filterTitle}</label>`,
          );
        });
    },
  });
  $("div.toolbar")
    .html(
      '<div class="toggle-columns float-start m-1">Hide/Show Column: <a class="toggle-vis" data-column="0">Name</a> - <a class="toggle-vis" data-column="1">Start Date</a> - <a class="toggle-vis" data-column="2">End Date</a> - <a class="toggle-vis" data-column="3">Department</a> - <a class="toggle-vis" data-column="4">Clerkship</a> - <a class="toggle-vis" data-column="5">Affiliate Site</a>',
    )
    .addClass("pt-2");
  $("#roster_filter").addClass("pt-2");
  $("a.toggle-vis").on("click", function (e) {
    e.preventDefault();

    let column = table.column($(this).attr("data-column"));
    column.visible(!column.visible());
  });
});
